import styled from 'styled-components';

export const MenuItem = styled.div`
    margin:0 0 5px 0;
    padding: 5px 10px;
    box-sizing: border-box; 
    color: #000;
    border:1px solid #000;
    min-width: 280px;
    outline-offset: 2px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Wrapper = styled.div`
margin: 10px 0;
`;

export const Title = styled.h3`
    font-weight: bold;
`;
